import { serialize } from "serializr";
import { ApiService } from "../../api";
import { Library } from "./Library";

export interface ILibraryPatch {
	name?: string;
	code?: string;
	is_elearning?: boolean;
}

/**
 * Functions for working with libraries.
 */
export class LibraryService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	/**
	 * Find all product libraries
	 */
	public async findAll(): Promise<Library[]> {
		const libraryData = await this.apiService.get(
			"/api/v1/product/libraries",
		);
		const libraries = await libraryData.json();

		return Library.fromJsonArray(libraries);
	}

	/**
	 * Saves only the fields given.
	 */
	public async patch(id: number, fields: ILibraryPatch): Promise<Library> {
		const response = await this.apiService.patch(
			`/api/v1/product/libraries/${id}`,
			fields,
		);
		return Library.fromJson(await ApiService.readJson(response));
	}

	public async create(library: Library): Promise<Library> {
		const libraryData = await this.apiService.post(
			`/api/v1/product/libraries/`,
			serialize(Library, library),
		);
		const newLibrary = await libraryData.json();
		return Library.fromJson(newLibrary);
	}
}
